<template>
  <div :class="$style.page">
    <!-- 价格类型 -->
    <div :class="$style.options">
      <template v-for="option in options">
        <div
          :class="{
            [$style.option_item]: true,
            [$style.option_active]: optionId === option.id,
          }"
          :key="option.id"
          @click="() => clickOption(option.id)"
        >
          <p :class="$style.option_title">{{ option.title }}</p>
          <span>{{ option.desc }}</span>
        </div>
      </template>
    </div>

    <!-- 价格列表 -->
    <div
      v-if="showList[optionId].length > 0"
      :class="$style.list"
      :key="optionId"
    >
      <div :class="$style.list_header">
        <div :class="$style.list_row">
          <div :class="$style.list_col">域名后缀</div>
          <template v-for="item in showList[optionId][0].suffixPriceList">
            <div :class="$style.list_col" :key="item.levelId">
              {{ item.levelName }}
            </div>
          </template>
        </div>
      </div>

      <div :class="$style.list_content">
        <template v-for="item in showList[optionId]">
          <div :class="$style.list_row" :key="item.id">
            <div :class="$style.list_col">
              <span :class="$style.name">{{ item.suffixName }}</span>
              <span :class="$style.remark">{{ item.desc }}</span>
            </div>

            <template v-for="item in item.suffixPriceList">
              <div :class="$style.list_col" :key="item.levelId">
                <span
                  :class="item.activityPrice != null ? $style.price : '' "
                  v-if="item.activityPrice == null"
                >
                  {{ item.price }}/年
                </span>
                <span v-else :class="$style.price_activity">
                  {{ item.activityPrice }}/年
                </span>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>

    <!-- 注意事项 -->
    <div :class="$style.attention">
      <p :class="$style.title">注意事项：</p>
      <p :class="$style.con">
        1、注册域名请先阅读：《域名注册服务协议》<br />
        2、CN域名注册后要经过CNNIC审核，如果审核不通过，则域名注册会被退回。
      </p>
    </div>

    <RightNav />
  </div>
</template>

<script>
import { getPriceList } from "@server/index";

import RightNav from "@components/RightNav.vue";

export default {
  name: "DomainPrice",
  components: { RightNav },
  data() {
    return {
      isLogin: "",
      options: [
        {
          id: 0,
          title: "域名注册",
          desc: "首年注册",
        },
        {
          id: 1,
          title: "续费价格",
          desc: "单年续费价格",
        },
        { id: 2, title: "转入价格", desc: "含一年续费价格" },
      ],
      optionId: 0,
      showList: {
        0: [],
        1: [],
        2: [],
      },
    };
  },
  mounted() {
    this.fetchData(this.optionId);
  },
  methods: {
    toCart() {
      this.$router.push("/dCart");
    },

    clickOption(id) {
      this.optionId = id;
      this.fetchData(id);
    },

    async fetchData(id) {
      if (this.showList[id].length > 0) return;

      try {
        const res = await getPriceList(id);
        const { code, message, data } = res;

        if (code === 200) {
          this.showList[id] = data;
        } else {
          this.$message({ message });
        }
      } catch (e) {
        this.$message({ message: e?.message });
      }
    },
  }
};
</script>

<style lang="scss" module scoped>
.page {
  width: rem(1200);
  margin: rem(80) auto rem(100);

  .options {
    display: flex;
    justify-content: space-between;
    padding-bottom: 3px;
    margin-bottom: rem(50);
    background: $theme-color;

    .option_item {
      flex: 1;
      height: rem(115);
      background: #797d85;
      font-size: rem(14);
      font-family: Source Han Sans CN;
      color: #fff;
      line-height: rem(28);

      @include flex();
      flex-direction: column;
      cursor: pointer;

      &:not(:last-child) {
        border-right: $border-1;
      }

      &.option_active {
        background: $theme-color;
      }

      .option_title {
        font-size: rem(20);
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: rem(34);
      }
    }
  }

  .list {
    width: 100%;
    margin-bottom: rem(50);

    .list_row {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      background: #fff;
      border-bottom: 1px solid #e6e6e6;
    }

    .list_col {
      flex: 0 0 rem(198);
      text-align: center;

      &:first-child {
        flex-grow: 1;
      }

      &:not(:last-child) {
        border-right: 1px solid #e6e6e6;
      }
    }

    .list_header {
      .list_row {
        background: #9fa1a8;
      }

      .list_col {
        height: rem(74);
        font-size: rem(16);
        font-weight: bold;
        color: #ffffff;
        line-height: rem(74);
      }
    }

    .list_content {
      font-size: rem(14);
      color: #555;

      .list_row:nth-child(odd) {
        background: #f7f7fa;
      }

      .list_col {
        height: rem(70);
        line-height: rem(70);
        overflow: hidden;

        &:first-child {
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
        }

        .name {
          width: 100px;
          text-decoration: underline;
        }

        .remark {
          flex: 1;
          align-self: center;
          padding-right: rem(8);
          @include lamp-clamp(3);
          line-height: rem(24);
          text-align: left;
        }

        .price {
          text-decoration: line-through;
          color: #999;
          margin-right: rem(20);
        }
      }
    }
  }

  .attention {
    padding: rem(20) rem(60);
    background: #fff;
    .title {
      font-size: rem(16);
      font-weight: bold;
      color: #333;
      line-height: rem(36);
    }

    .con {
      font-size: rem(14);
      color: #888;
      line-height: rem(30);
    }
  }
}
</style>
